import { useEffect } from 'react';

export const useMouseTracking = ({
  stateRef,
  onMouseMove,
  onMouseUp
}) => {
  useEffect(() => {
    const handleMouseMove = (e) => {
      onMouseMove?.(e, stateRef.current);
    };

    const handleMouseUp = (e) => {
      onMouseUp?.(e, stateRef.current);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [onMouseMove, onMouseUp, stateRef]);
};
